import React from "react";
import { Box, Modal } from "@mui/material";
import Slide from "@mui/material/Slide";
import CircularProgress from "@mui/material/CircularProgress";

const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1300,
};

const myStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "600px",
  background: "var(--qv-bg-ffffff, #fff)",
  borderRadius: "12px",
  padding: "0",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  maxHeight: "80vh",
  overflow: "hidden",
};

const scrollContent = { padding: "20px", overflowY: "auto", flex: 1 };
const footer = {
  padding: "15px 20px",
  borderTop: "1px solid #ddd",
  background: "var(--qv-bg-ffffff, #fff)",
  bottom: 0,
  borderBottomLeftRadius: "12px",
  borderBottomRightRadius: "12px",
};
const card = { marginTop: "15px", padding: "12px", background: "var(--qv-bg-f5f5f5, #f5f5f5)", borderRadius: "8px" };
const labelRow = { display: "flex", justifyContent: "space-between", marginBottom: "6px" };

const formatVehicle = (v) => {
  if (!v) return null;
  const parts = [v.color, v.make, v.model].filter(Boolean).join(" ");
  return parts || v.type || null;
};

const DriverContactModal = ({ open, onClose, isLoading, payload }) => {
  const data = payload?.data || {};
  const courier = data.courier || {};
  const vehicle = courier.vehicle || {};
  const location = courier.location || {};
  const etas = data.etas || {};
  const isActive = payload?.is_active === true;
  const inactiveReason = payload?.reason;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-describedby="driver-contact-modal"
      className="delete-modal-outer-div"
      closeAfterTransition
    >
      <Slide direction="down" in={open} mountOnEnter unmountOnExit>
        <Box style={overlayStyles}>
          <Box className="delete-Box-modal qv-order-modal-panel" style={myStyles}>
            <div style={scrollContent}>
              <h3 style={{ marginBottom: "12px", fontWeight: 500 }}>Contact Driver</h3>

              {isLoading ? (
                <Box style={{ display: "flex", justifyContent: "center", padding: "30px" }}>
                  <CircularProgress sx={{ color: "var(--qv-tx-000000, #000000) !important" }} />
                </Box>
              ) : !isActive ? (
                <div style={card}>
                  <p style={{ fontWeight: 500, marginBottom: "8px" }}>Driver contact unavailable</p>
                  <p style={{ color: "var(--qv-tx-555555, #555)" }}>
                    {inactiveReason === "no_delivery" && "No Uber delivery has been dispatched for this order yet."}
                    {inactiveReason === "awaiting_courier" && "Delivery dispatched. Waiting for a courier to be assigned."}
                    {inactiveReason === "delivered" && "Delivery has been completed."}
                    {(inactiveReason === "cancelled" || inactiveReason === "canceled" || inactiveReason === "driver_canceled") &&
                      "Delivery was cancelled."}
                    {inactiveReason === "returned" && "Delivery was returned to store."}
                    {!["no_delivery", "awaiting_courier", "delivered", "cancelled", "canceled", "driver_canceled", "returned"].includes(
                      inactiveReason
                    ) && (payload?.message || "Driver contact not available for this delivery.")}
                  </p>
                  {data.delivery_id && (
                    <p style={{ marginTop: "8px", fontSize: "0.9em", color: "var(--qv-tx-666666, #666)" }}>
                      <b>Delivery ID:</b> {data.delivery_id}
                    </p>
                  )}
                </div>
              ) : (
                <>
                  <div style={card}>
                    <p style={{ fontWeight: 500, marginBottom: "8px" }}>Driver</p>
                    <div style={labelRow}>
                      <span>Name</span>
                      <span style={{ fontWeight: 500 }}>{courier.name || "N/A"}</span>
                    </div>
                    <div style={labelRow}>
                      <span>Phone</span>
                      <span style={{ fontWeight: 500 }}>
                        {courier.phone ? (
                          <a href={`tel:${courier.phone}`} style={{ color: "var(--qv-brand-text, #0a64f9)" }}>
                            {courier.phone}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </span>
                    </div>
                    {courier.img_url && (
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <img
                          src={courier.img_url}
                          alt="Driver"
                          style={{ width: "72px", height: "72px", borderRadius: "50%", objectFit: "cover" }}
                        />
                      </div>
                    )}
                  </div>

                  <div style={card}>
                    <p style={{ fontWeight: 500, marginBottom: "8px" }}>Vehicle</p>
                    <div style={labelRow}>
                      <span>Type</span>
                      <span style={{ fontWeight: 500, textTransform: "capitalize" }}>{vehicle.type || "N/A"}</span>
                    </div>
                    <div style={labelRow}>
                      <span>Description</span>
                      <span style={{ fontWeight: 500 }}>{formatVehicle(vehicle) || "N/A"}</span>
                    </div>
                    {vehicle.license_plate && (
                      <div style={labelRow}>
                        <span>License Plate</span>
                        <span style={{ fontWeight: 500 }}>{vehicle.license_plate}</span>
                      </div>
                    )}
                  </div>

                  <div style={card}>
                    <p style={{ fontWeight: 500, marginBottom: "8px" }}>Status & ETA</p>
                    <div style={labelRow}>
                      <span>Delivery status</span>
                      <span style={{ fontWeight: 500, textTransform: "capitalize" }}>
                        {(data.delivery_status || "").replaceAll("_", " ") || "Unknown"}
                      </span>
                    </div>
                    {etas.pickup_eta && (
                      <div style={labelRow}>
                        <span>Pickup ETA</span>
                        <span style={{ fontWeight: 500 }}>{etas.pickup_eta}</span>
                      </div>
                    )}
                    {etas.dropoff_eta && (
                      <div style={labelRow}>
                        <span>Dropoff ETA</span>
                        <span style={{ fontWeight: 500 }}>{etas.dropoff_eta}</span>
                      </div>
                    )}
                    {etas.courier_eta && (
                      <div style={labelRow}>
                        <span>Courier ETA</span>
                        <span style={{ fontWeight: 500 }}>{etas.courier_eta}</span>
                      </div>
                    )}
                    {data.tracking_url && (
                      <div style={{ marginTop: "8px" }}>
                        <a
                          href={data.tracking_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "var(--qv-brand-text, #0a64f9)" }}
                        >
                          Open live tracking
                        </a>
                      </div>
                    )}
                    {(location.lat !== null && location.lat !== undefined) && (
                      <div style={{ marginTop: "8px", fontSize: "0.85em", color: "var(--qv-tx-666666, #666)" }}>
                        Last courier location: {location.lat}, {location.lng}
                        {location.updated_at ? ` (updated ${location.updated_at})` : ""}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            <div style={footer}>
              <button
                onClick={onClose}
                style={{ background: "var(--qv-brand, #0a64f9)", color: "#fff", width: "100%", padding: "10px 0", borderRadius: "6px" }}
              >
                Close
              </button>
            </div>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default DriverContactModal;
